import { getFullPathFromUrl, isNilOrEmpty } from 'packages/core'
import config from 'config'

export const headerHeight = 70
export const subHeaderHeight = 70
export const smallScreenWidth = '1022px'
export const tabletScreenWidth = '768px'
export const mobileScreenWidth = '767px'
export const imagesDisabled =
    config.DISABLE_IMAGES?.toString().toLowerCase() === 'true'


export const getFullImageUrl = (imagePath: any) =>
    !isNilOrEmpty(imagePath) ? `${config.BASE_EID_URL}${imagePath}` : undefined

export const paginate = (items: any, pageNumber: any, pageSize: any) => {
    const startIndex = (pageNumber - 1) * pageSize
    const end = startIndex + pageSize
    items = items.slice(startIndex, end)
    return items
}

export const getAppliedFiltersValues = (state: any) => {
    let values: any = []
    const defaultFiltersKeys = [
        'highLevelClassification',
        'groupType',
        'uncPath',
        'businessFunction',
        'location',
        'application',
        'rights',
        'accountStoreUsageType',
        'accountStore',
        'showOnlyAzureApplications',
        'ownedBy',
        'advancedSearch.forms.name',
        'advancedSearch.forms.description',
        'advancedSearch.forms.friendlyName',
    ]
    defaultFiltersKeys.map((key) => {
        if (state[key]) {
            values.push({ [key]: state[key] })
        }
    })
    return values
}


export const defaultDataProtectedSubcomponent = 'NotProtected'


export const ITEMS_VIEW = {
    LIST: 'list',
    CARD: 'card',
}



export const TREE_VIEW_LEVELS = 2
export const TREE_CHILD_VIEW_LEVELS = 1
export const DEFAULT_EMPTY_UUID = '00000000-0000-0000-0000-000000000000'


export const showSearchToLoadMessage = (
    route: string,
    searchKey: any,
    isEnterPressed: boolean,
) => {
    try {
        if (isEnterPressed === true) {
            return false
        }
        const isSearchToLoad =
            config?.SEARCH_TO_LOAD && config?.SEARCH_TO_LOAD === 'true'
                ? true
                : false
        return (
            isSearchToLoad &&
            config?.SEARCH_TO_LOAD_TABS?.includes(route) &&
            searchKey.length < 3
        )
    } catch (err) {
        return false
    }
}

export const ELIGIBILITY_TYPE_ID = {
    Eligible: 1,
    Suggested: 2,
    PreApproved: 3,
}


export const checkIfAllChildsShowInTree = (explorer: any) => {
    if (!explorer?.children || !Array.isArray(explorer.children)) {
        return true
    }

    return explorer.children.every((child: any) => {
        // Check if current child has showInTree as false
        if (child?.showInTree !== false) {
            return true
        }
        // Recursively check all descendants
        return checkIfAllChildsShowInTree(child)
    })
}

export const GROUP_TO_BUSINESS_ROLE_ITEM_STATUS_TYPE = {
    NotValidated: 1,
    Valid: 2,
    Invalid: 3,
    Ignored: 4,
    Completed: 5,
    Error: 6,
    PublishQueued: 7,
    Publishing: 8,
}
export const RTA_INBOX_TYPES = {
    APPLICATION_ROLE_ATTRIBUTE: 1,
    GROUP_ELIGIBILITY: 2,
    TEMPLATE_BUSINESS_ROLE: 3,
    DERIVED_BUSINESS_ROLE: 4,
    GROUP_TO_BUSINESS_ROLE: 5,
}
